import { Component, Input } from '@angular/core';
import { ReviewsSliderComponent } from '../reviews-slider/reviews-slider.component';
import { AyrCommentsModel } from '../../../model/ayr-comments.model';

@Component({
    selector: 'app-ayr-reviews',
    imports: [ReviewsSliderComponent],
    templateUrl: './ayr-reviews.component.html',
    styleUrl: './ayr-reviews.component.scss'
})
export class AyrReviewsComponent {
  @Input() ayrComments?: AyrCommentsModel[];
}
